// extracted by mini-css-extract-plugin
module.exports = {"subHeading":"_PrimaryHeading_subHeading__1i7yU"};